export const jobStatusNames = {
    New: 'new',
    Assigned: 'assigned',
    InProgress: 'in-progress',
    Processed: 'processed',
    Verification: 'verification',
    Done: 'done',
    Rejected: 'rejected',
    PaidToDealer: 'paid-to-dealer',
};
